<template>
    <div class="login">
        <div class="back">
            <div class="div-center">
                <div class="content">
                    <h3>Login</h3>
                    <hr />
                    <form v-on:keyup="onKeyUp">
                        <div class="form-group">
                            <label for="email">Email address</label>
                            <input type="email" class="form-control" id="email" v-model="email" placeholder="Email">
                        </div>
                        <div class="form-group">
                            <label for="password">Password</label>
                            <input type="password" class="form-control" id="password" v-model="password" placeholder="Password">
                        </div>
                        <br>
                        <button type="button" class="btn btn-primary" @click="login">Login</button><hr/>
                        
                        <router-link v-if="tennant.AllowRegistration" class="nav-link" to="register">Register</router-link>

                        <a href="#" class="nav-link" @click="resendRegistrationEmail">Resend Registration Email</a>
                        
                        <router-link class="nav-link" to="reset">Reset Password</router-link>
                        <br/>

                        <div class="error">{{errorMessage}}</div>
                        <div class="info">{{infoMessage}}</div>
                    </form>
                </div>                   
            </div>
        </div> 
    </div>
</template>

<script>
    export default {
        name: 'Login',
        emits: ['loggedIn'],
        data() {
            return {   
                email: '',
                password: '',
                errorMessage: '',
                infoMessage: '',
                tennant: {}     
            };
        },
        created: function () {
            this.email = localStorage.getItem('userEmail');                    
        },
        mounted: function () {

        },
        methods: {
            login() {
                this.clearMessages();
                this.$http.post(this.apiUrl + 'users/authenticate', { Email: this.email, Password: this.password })
                    .then((response) => {
                        this.storeUserData(response.data);
                        this.$emit('loggedIn')                           
                        if(this.$route.params.nextUrl != null){
                            this.$router.push(this.$route.params.nextUrl)
                        }
                        else {
                            this.$router.push('home')                            
                        }                      
                    }, (error) => {
                        switch(error.response.status) {
                            case 401:
                                this.errorMessage = 'Unauthorised';
                                break;
                            case 403:
                                this.errorMessage = 'Forbidden';
                                break;
                            default:
                                this.errorMessage = 'Error';
                        }
                    });
            },
            resendRegistrationEmail() {
                this.clearMessages();
                this.$http.post(this.apiUrl + 'users/resendregistrationemail', { Email: this.email })
                    .then((response) => {
                        this.infoMessage = "Registration email re-sent";                                             
                    }, (error) => {
                        switch(error.response.status) {
                            case 401:
                                this.errorMessage = 'Unauthorised';
                                break;
                            case 403:
                                this.errorMessage = 'Forbidden';
                                break;
                            default:
                                this.errorMessage = 'Error';
                        }
                    });
            },  
            clearMessages() {
                this.infoMessage = "";
                this.errorMessage = "";
            },
            onKeyUp: function(e) {
                if (e.keyCode === 13) {
                    this.login();
                }
            }        
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    th, td {
        text-align: left
    }

    .back {
        background: #e2e2e2;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0
    }

    .div-center {
        width: 400px;
        height: 400px;
        background-color: #fff;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
        overflow: auto;
        padding: 1em 2em;
        border-bottom: 2px solid #ccc;
        display: table;
    }

    div.content {
        display: table-cell;
        vertical-align: middle;
    }

    div.error {
        color: red;
        display: inline;
        padding-left: 0px;
    }

    div.info {
        color: green;
        display: inline;
        padding-left: 0px;
    }

    a.nav-link {
        padding-left: 0;
    }
</style>

